





























import { listFactory } from '@/main/pages';
import { listName } from '@/main/store/listEditTypes';
import { columnsToCamelCase, Row } from '@/main/utils/table';
import { objectToCamelCaseShallow } from '@/main/utils/stringHelper';

import { previewButton } from '@/main/utils/tableOperations';

import DmsListLayout from '@/main/layout/DmsListLayout.vue';

import CustomerFeedback from '@/main/pages/CustomerFeedback.vue';

import _ from 'lodash';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import { apiProvider } from './api';
import { VOZIDLO_DATA_TYPE, VOZIDLO_DATA } from './constants';
import { store } from './store/dataList';


import FeedbackRating from './components/FeedbackRating.vue';


export default listFactory(VOZIDLO_DATA, store).extend({
	components: { DmsListLayout, DmsPdfDialog, FeedbackRating, CustomerFeedback },
	name: listName(VOZIDLO_DATA),
	data() {
		return {
			isDialogVisible: false as boolean,
			feedbackQuestions: [],
			modelTitle: '' as string,
			tiskDialog: false as boolean,
			vehicleHistoryFilter: { VozidloId: null as number | null },
			vServiceHistoryUrl: '/Servis/Reports/GetVehicleServiceHistory' as string,
		};
	},
	computed: {
		extraButtons(): {} {
			if (this.dmsSys.CustomerFeedbackPrp && this.props.filter.type === VOZIDLO_DATA_TYPE.HISTORIEOPRAV) {
				return { ...previewButton(this.viewDetailsClick) };
			}
			return {};
		},
		overallRating(): number {
			const iColumnIndex = this.table!.cellNames!.FEEDBACK_RATING;
			return _.reduce(this.table.rows, (sum, row) => sum + row.cells[iColumnIndex], 0) / this.table.rows.length;
		},
	},
	methods: {
		async loadData() {
			await this.schema();
			await this.tableData();
		},
		async viewDetailsClick(e: any, cells: any) {
			const OrderId = Number(cells[0]);
			this.modelTitle = `${this.LocalizePopisostatni('CustomerRatingLbl')} (${this.LocalizePopisPoli('ORDER_NO')} :${OrderId})`;
			this.startLoading();
			const { data: questions } = await apiProvider.getCustomerFeedBackData(OrderId);
			this.isDialogVisible = true;
			this.feedbackQuestions = questions.FeedbackQuestions;
			this.endLoading();
		},
		async showQueWiseAvgData() {
			this.startLoading();
			this.modelTitle = `${this.LocalizePopisostatni('CustomerRatingLbl')} (${this.LocalizePopisPoli('KAROSERIE_NR')} ${this.props.filter.VIN} )`;
			const { filter } = this.props;
			const { data: feedBackResp }	= await apiProvider.vechicleCustomerAvgFeedbackRows(filter);
			this.feedbackQuestions = feedBackResp;
			this.isDialogVisible = true;
			this.endLoading();
		},

		async schema() {
			switch (this.props.filter.type) {
				case VOZIDLO_DATA_TYPE.HISTORIEOPRAV: {
					const { data } = await apiProvider.histOpravSchema();
					this.table.columns = columnsToCamelCase(data.Columns);
					this.vehicleHistoryFilter = { VozidloId: this.props.filter.VozidloId };
					break;
				}
				case VOZIDLO_DATA_TYPE.CUSTOMER_FEEDBACK: {
					const { data } = await apiProvider.customerFeedbackSchema();
					this.table.columns = columnsToCamelCase(data.Columns);
					break;
				}
				case VOZIDLO_DATA_TYPE.OBRATYOPRAV: {
					const { data } = await apiProvider.obratyOpravSchema();
					this.table.columns = columnsToCamelCase(data.Columns);
					break;
				}
				case VOZIDLO_DATA_TYPE.SDA: {
					const { data } = await apiProvider.sdaSchema();
					this.table.columns = columnsToCamelCase(data.Columns);
					break;
				}
				default: {
					const { data } = await apiProvider.serviceKeySchema();
					this.table.columns = columnsToCamelCase(data.Columns);
					break;
				}
			}
		},
		async tableData() {
			const { filter } = this.props;
			switch (filter.type) {
				case VOZIDLO_DATA_TYPE.HISTORIEOPRAV: {
					const { data } = await apiProvider.histOpravRows(filter);
					this.table.rows = data.map((row: Row) => objectToCamelCaseShallow(row));
					break;
				}
				case VOZIDLO_DATA_TYPE.CUSTOMER_FEEDBACK: {
					const { data } = await apiProvider.vechicleCustomerAvgFeedbackRows(
						filter,
					);
					this.table.rows = data.map((row: Row) => objectToCamelCaseShallow(row));
					break;
				}
				case VOZIDLO_DATA_TYPE.OBRATYOPRAV: {
					const { data } = await apiProvider.obratyOpravRows(filter);
					this.table.rows = data.map((row: Row) => objectToCamelCaseShallow(row));
					break;
				}
				case VOZIDLO_DATA_TYPE.SDA: {
					const { data } = await apiProvider.sdaRows(filter);
					this.table.rows = data.map((row: Row) => objectToCamelCaseShallow(row));
					break;
				}
				default: {
					const { data } = await apiProvider.serviceKeyRows(filter);
					this.table.rows = data.map((row: Row) => objectToCamelCaseShallow(row));
					break;
				}
			}
		},
	},
});
